import { useTranslation } from "react-i18next";

function Privacy() {
  const { t } = useTranslation();
  const data = t("privacy.data", { returnObjects: true });

  return (
    <section id="privacy" className="privacy-section">
      <div>
        <div className="base-text-container">
          <h2 className="base-title">{t("privacy.title")}</h2>

          <p className="base-subtitle">{t("privacy.subtitle1")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("privacy.address")}
          </p>
          <p className="base-paragraph whitespace-pre-line">
            {t("privacy.text1")}
          </p>

          <p className="base-subtitle">{t("privacy.subtitle2")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("privacy.text2")}
          </p>
          <ul className="list-disc pl-6">
            {data.map((course, index) => (
              <li key={index}>{course}</li>
            ))}
          </ul>
          <p className="base-paragraph whitespace-pre-line">
            {t("privacy.text2bis")}
          </p>

          <p className="base-subtitle">{t("privacy.subtitle3")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("privacy.text3")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Privacy;
